<template>
  <div class="vip-container pb-[100px]" :class="{ 'from-person': isFromPerson }">
    <!-- 从个人中心跳转时显示顶部导航栏 -->
    <van-nav-bar v-if="isFromPerson" :title="t('vip.title')" :border="false" class="custom-nav-bar">
      <template #left>
        <Button type="back" @click="onClickLeft" />
      </template>
    </van-nav-bar>

    <div class="vip" :class="{ 'from-person': isFromPerson }">
      <div class=" vip-header py-[14px] relative">
        <!-- <div class="bg-[#F25A56] rounded-[3px] color-[#ffffff] text-[9px] align-center absolute top-[6px] left-[16px]"
          style="font-weight: bold;padding: 4px 3px;">{{ t('vip.currentLevel') }}</div> -->
        <div class="flex items-center justify-between mx-[10px] ">
          <div class="flex  flex items-center">
            <img :src="imgUrl + vipStore.vipInfo?.currentVip?.icon" alt="" class="w-[44px] h-[22px]"
              style="object-fit: cover;">
            <div class="ml-[18px]">
              <!-- 根据是否为最高等级显示不同内容 -->
              <template v-if="isMaxLevel">
                <div class="color-[#60B289] text-[11px]">
                  <span class="color-[#FFF000]">VIP{{ vipStore.vipInfo?.level }}</span>
                  <span class="color-[#60B289] ml-[4px]">{{ t('person.maxLevelReached') }}</span>
                </div>
              </template>
              <template v-else>
                <div class="color-[#FEFEFE] text-[11px]">
                  {{ t('vip.nextLevel') }}
                  <!-- Siga -->
                  <span class="color-[#FEF64A]">VIP{{ vipStore.vipInfo?.level + 1 }}
                  </span>
                </div>
                <div class="color-[#FEFEFE] text-[11px] color-[#ffffff] mt-[7px]">
                  <!-- Ainda precisa apostar -->
                  {{ t('vip.needBet') }}
                  <span class="color-[#FFFFFF]">{{ getNextLevelBetRequirement() }}
                  </span>
                </div>
                <div v-if="getNextLevelRechargeRequirement() > 0" class="color-[#60B289] text-[11px] color-[#60B289]">
                  {{ t('vip.needRecharge') }}
                  <span class="color-[#FFFFFF]">
                    {{ getNextLevelRechargeRequirement() }}
                  </span>
                </div>
              </template>
            </div>
          </div>
          <div class="mr-[4px]">
            <Button type="vip" class="!text-[11px]" :disabled="!hasRewardsToCollect" @click="handleDrawAllRewards">
              <div class="mt-[4px]">
                {{ t('vip.collectAll') }}
              </div>
            </Button>
            <Button type="vip" class="!text-[11px]" @click="goToHistories">
              <div class="mt-[4px]">
                {{ t('vip.histories') }}
              </div>
            </Button>
          </div>
        </div>
      </div>
      <!-- <div class="text-[#ffffff] text-[14px] font-bold mt-[15px]">{{ t('vip.vipLevelList') }}</div> -->
      <div class="activity-header bg-[#082C21] p-[10px] rounded-[6px] mt-[12px]">
        <div class="tabs" ref="tabsContainer">
          <div v-for="(tab, idx) in availableTabs" :key="tab.value" :class="['tab-item', { active: idx === activeTab }]"
            @click="handleTabClick(idx)" :ref="el => tabRefs[idx] = el">
            <span class="tab-label-wrapper">
              {{ tab.label }}
              <!-- 为每个标签添加红点 -->
              <span v-if="getTabBadgeStatus(tab.type)" class="tab-badge-dot"></span>
              <span v-if="idx === activeTab" class="tab-underline"></span>
            </span>
          </div>
        </div>
        <div class="color-[#60B289] text-[12px] lh-[15px]" v-if="activeTab === 3">
          <div class="h-[1px] bg-[#1F6749]"></div>
          <p class="mt-[10px]">{{ t('vipRecompensas.title') }}</p>
          <p class="mt-[10px]">{{ t('vipRecompensas.rule1') }}</p>
          <p class="mt-[10px]">{{ t('vipRecompensas.rule2') }}</p>
          <p class="mt-[10px]">{{ t('vipRecompensas.rule3') }}</p>
          <p class="mt-[10px]">{{ t('vipRecompensas.chartTitle') }}</p>

        </div>
        <div class="h-[176px] mt-[12px] relative table-container">
          <div class=" w-full h-full z-2 overflow-y-auto">
            <KeepAlive>
              <Suspense>
                <template #default>
                  <component :is="currentComponent" @show-reward="handleShowReward" />
                </template>
                <template #fallback>
                  <div class="loading-container">
                    <div class="loading-spinner"></div>
                    <div class="loading-text">{{ t('vip.loading') }}</div>
                  </div>
                </template>
              </Suspense>
            </KeepAlive>
          </div>

        </div>

        <!-- 底部说明文字和按钮 -->
        <div class="vip-bottom-content" :class="{ 'from-person': isFromPerson }">
          <div class="mt-[11px] color-[#60B289] text-[12px] lh-[15px]">
            <p class="mt-[10px]">{{ t('vip.instructions') }}</p>
            <p class="mt-[10px]">{{ t('vip.promotionRule') }}</p>
            <p class="mt-[10px]">{{ t('vip.dailySalary') }}</p>
            <p class="mt-[10px]">{{ t('vip.weeklySalary') }}</p>
            <p class="mt-[10px]">{{ t('vip.monthlySalary') }}</p>
            <p class="mt-[10px]">{{ t('vip.rewardExpire') }}</p>
            <p class="mt-[10px]">{{ t('vip.auditInstruction') }}</p>
            <p class="mt-[10px]">{{ t('vip.activityStatement') }}</p>
            <p class="mt-[10px]">{{ t('vip.explanation') }}</p>
          </div>
        </div>
      </div>



    </div>

    <!-- 奖励弹窗 -->
    <RewardDialog v-model:show="showRewardDialog" :amount="rewardAmount" @confirm="handleRewardConfirm" />

    <!-- 登录弹窗 -->
    <!-- <AuthDialog
            v-model:show="showAuthDialog"
            :is-login="true"
            @close="handleAuthDialogClose"
        /> -->
  </div>
</template>

<script setup lang="ts">
import { RedDot } from "@/components/RedDot"
import { Button } from "@/components/Button"
import * as GameApi from '@/api/game'
import { ref, nextTick, shallowRef, defineAsyncComponent, computed, watch, onMounted, onBeforeUnmount } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useVipStore } from '@/stores/modules/vip'
import { useUserStore } from '@/stores/modules/user'
import useUIStore from '@/stores/modules/ui'
import RewardDialog from '@/components/RewardDialog.vue'
// 移除 AuthDialog 导入，因为现在是全局的
// import AuthDialog from '@/components/AuthDialog.vue'
// 移除认证弹窗工具函数导入，因为现在是全局的
// import { showLoginDialog } from '@/utils/auth-dialog'
import { numberFormat } from '@/utils/formatter'
const { t } = useI18n()

const imgUrl = import.meta.env.VITE_IMG_URL
const route = useRoute()
const router = useRouter()
const vipStore = useVipStore()
const userStore = useUserStore()
const uiStore = useUIStore()

// 移除本地的认证弹窗状态管理
// const showAuthDialog = ref(false)

const goToHistories = () => {
  router.push({
    path: '/activity',
    query: {
      tab: 'historico'  // 直接使用标签值，活动页面会根据这个值自动切换到对应标签
    }
  })
  // 设置来源标记
  sessionStorage.setItem('fromPerson', 'false')
}
const params = {
  type: 0
}

// 弹窗相关状态
const showRewardDialog = ref(false)
const rewardAmount = ref<any>({})

// 处理子组件显示奖励弹窗
const handleShowReward = (amount: any) => {
  rewardAmount.value = amount
  showRewardDialog.value = true
}

// 移除这个函数，因为现在使用全局状态管理
// const handleAuthDialogClose = () => {
//     showAuthDialog.value = false
//     // 如果用户关闭登录弹窗且未登录，跳转到Events标签页
//     if (!userStore.isLoggedIn) {
//         router.replace({
//             path: '/activity',
//             query: { tab: 'eventos' }
//         })
//     }
// }

const drawAllRewards = () => {
  console.log('params:', params)
  GameApi.drawReward(params).then(res => {
    // 显示奖励弹窗
    rewardAmount.value = res.data;
    showRewardDialog.value = true
    // 注意：这里不立即刷新数据，等弹窗确认后再刷新
  }).catch(err => {
    console.error('领取失败:', err)
  })
}

// 处理领取全部奖励的点击事件
const handleDrawAllRewards = () => {
  // 检查登录状态
  if (!userStore.isLoggedIn) {
    window.$showLoginDialog() // 使用全局函数
    return
  }

  if (hasRewardsToCollect.value) {
    drawAllRewards()
  }
}

// 处理奖励确认
const handleRewardConfirm = async () => {
  // 弹窗关闭后的处理逻辑
  console.log('奖励已确认')

  // 等待一下确保API处理完成
  await new Promise(resolve => setTimeout(resolve, 500))

  // 强制刷新VIP数据，这会更新所有子组件的状态
  await vipStore.loadVipData(true) // 传入true表示强制刷新

  // 更新VIP红点状态
  updateVipBadge()

  // 强制更新计算属性
  await nextTick()
}

// 更新VIP红点状态
const updateVipBadge = () => {
  const hasRewards = vipStore.vipData.drawRewardList && vipStore.vipData.drawRewardList.length > 0
  uiStore.setActivityBadge('vip', hasRewards)
}

// 监听VIP数据变化，更新红点状态
watch(() => vipStore.vipData.drawRewardList, () => {
  updateVipBadge()
}, { deep: true })

// 判断是否从个人中心跳转
const isFromPerson = computed(() => {
  return route.path === '/activity' &&
    route.query.tab === 'vip' &&
    sessionStorage.getItem('fromPerson') === 'true'
})

// 返回上一页
function onClickLeft() {
  router.back()
}

// 检查是否有可领取的奖励
const hasRewardsToCollect = computed(() => {
  const drawRewardList = vipStore.vipData.drawRewardList || []
  console.log('drawRewardList:', drawRewardList) // 调试日志
  console.log('hasRewardsToCollect:', drawRewardList.length > 0) // 调试日志
  return drawRewardList.length > 0
})

// 添加判断是否为最高等级的计算属性
const isMaxLevel = computed(() => {
  // 使用类型断言或可选链操作符来避免TypeScript错误
  const configList = (vipStore.vipData as any)?.configList
  const currentLevel = (vipStore.vipInfo as any)?.level

  if (!configList || currentLevel === undefined || currentLevel === null) {
    return false
  }

  // 获取所有等级配置，找到最高等级
  const maxLevel = Math.max(...configList.map((config: any) => config.level))
  return currentLevel >= maxLevel
})

// 根据openReward数组动态生成可用的tabs
const availableTabs = computed(() => {
  const openReward = vipStore.vipData.openReward || [] // 修改这里：从vipData中获取
  const reserveGradeSwitch = vipStore.vipData.reserveGradeSwitch ?? true // 默认为true，如果为false则不显示保级奖励页签
  console.log('openReward:', openReward) // 调试信息
  console.log('vipStore.vipData:', vipStore.vipData) // 调试信息
  console.log('reserveGradeSwitch:', reserveGradeSwitch) // 调试信息

  const allTabs = [
    { label: t('vip.bonus'), value: 'Bônus', type: 1 },
    { label: t('vip.bonusDaily'), value: 'Bônus Diário', type: 2 },
    { label: t('vip.bonusWeekly'), value: 'Bônus Semanal', type: 3 },
    { label: t('vip.bonusMonthly'), value: 'Bônus Mensal', type: 4 },
    { label: t('vip.rewards'), value: 'Recompensas', type: 0 } // 保级奖励
  ]

  const filteredTabs = allTabs.filter(tab => {
    if (tab.type === 0) {
      // 如果reserveGradeSwitch为false，则不显示保级奖励页签
      return reserveGradeSwitch
    }
    return openReward.includes(tab.type)
  })

  console.log('filteredTabs:', filteredTabs) // 调试信息
  return filteredTabs
})

// 获取指定标签的红点状态 - 使用computed确保实时更新
const getTabBadgeStatus = (tabType: number) => {
  const drawRewardList = vipStore.vipData.drawRewardList || []
  return drawRewardList.includes(tabType)
}

// 动态生成对应的组件数组
const tabComponents = computed(() => {
  const components = []

  if (availableTabs.value.some(tab => tab.type === 1)) {
    components.push(defineAsyncComponent(() => import('./vip/VipBonusTable.vue')))
  }

  if (availableTabs.value.some(tab => tab.type === 2)) {
    components.push(defineAsyncComponent(() => import('./vip/VipBonusDaily.vue')))
  }

  if (availableTabs.value.some(tab => tab.type === 3)) {
    components.push(defineAsyncComponent(() => import('./vip/VipBonusWeekly.vue')))
  }

  if (availableTabs.value.some(tab => tab.type === 4)) {
    components.push(defineAsyncComponent(() => import('./vip/VipBonusMonthly.vue')))
  }

  if (availableTabs.value.some(tab => tab.type === 0)) {
    components.push(defineAsyncComponent(() => import('./vip/Recompensas.vue')))
  }

  console.log('tabComponents:', components.length) // 调试信息
  return components
})

const activeTab = ref(0)
const lastTabIndex = ref(0)
const tabsContainer = ref<HTMLElement | null>(null)
const tabRefs = ref<HTMLElement[]>([])

// 当前组件
const currentComponent = computed(() => {
  const component = tabComponents.value[activeTab.value] || tabComponents.value[0]
  console.log('currentComponent:', component, 'activeTab.value:', activeTab.value) // 调试信息
  return component
})

function handleTabClick(idx: number) {
  lastTabIndex.value = activeTab.value
  activeTab.value = idx
  nextTick(() => {
    scrollTabIntoView(idx)
  })
}

function scrollTabIntoView(idx: number) {
  const container = tabsContainer.value
  const tab = tabRefs.value[idx]
  if (container && tab) {
    if (idx > lastTabIndex.value) {
      // 往右点，tab 靠左
      const left = tab.offsetLeft - 10
      container.scrollTo({
        left: left > 0 ? left : 0,
        behavior: 'smooth'
      })
    } else if (idx < lastTabIndex.value) {
      // 往左点，tab 靠右
      const right = tab.offsetLeft - container.offsetWidth + tab.offsetWidth + 10
      container.scrollTo({
        left: right > 0 ? right : 0,
        behavior: 'smooth'
      })
    }
  }
}

// 计算下一级所需的投注金额
const getNextLevelBetRequirement = () => {
  const currentLevel = (vipStore.vipInfo as any)?.level || 0
  const currentBet = (vipStore.vipInfo as any)?.bet || 0

  // 从 configList 中获取下一级的配置
  const nextLevelConfig = (vipStore.vipData as any)?.configList?.find((config: any) => config.level === currentLevel + 1)

  if (nextLevelConfig && nextLevelConfig.advanceBet) {
    const requiredBet = nextLevelConfig.advanceBet - currentBet
    return requiredBet > 0 ? numberFormat(requiredBet, { minDecimals: 2 }) : 0
  }

  return 0
}

// 计算下一级所需的充值金额
const getNextLevelRechargeRequirement = () => {
  const currentLevel = (vipStore.vipInfo as any)?.level || 0
  const currentRecharge = (vipStore.vipInfo as any)?.recharge || 0

  // 从 configList 中获取下一级的配置
  const nextLevelConfig = (vipStore.vipData as any)?.configList?.find((config: any) => config.level === currentLevel + 1)

  if (nextLevelConfig && nextLevelConfig.advanceRecharge) {
    const requiredRecharge = nextLevelConfig.advanceRecharge - currentRecharge
    return requiredRecharge > 0 ? numberFormat(requiredRecharge, { minDecimals: 2 }) : 0
  }

  return 0
}

onMounted(async () => {
  // 检查登录状态
  if (!userStore.isLoggedIn) {
    window.$showLoginDialog() // 使用全局函数
    return
  }

  await vipStore.loadVipData()
})

onBeforeUnmount(() => {
})

// 在需要显示登录弹窗的地方使用全局状态管理
const handleSomeAction = () => {
  if (!userStore.isLoggedIn) {
    window.$showLoginDialog() // 使用全局函数
    return
  }
  // ... existing code ...
}
</script>

<style scoped lang="scss">
.vip-container {
  height: 100%;
  overflow-y: auto;

}

.vip-container.from-person {
  background: #083A36;
}

.vip-header {
  background: getPath('activity/vipHeaderBg.png') no-repeat center center;
  background-size: 100% 100%;
}

.table-container {
  background: getPath('activity/vitTableBg.png') no-repeat center center;
  background-size: 100% 100%;
  padding: 4px 6px;
}

.loading-text {
  color: #fff;
}

/* 添加导航栏样式 */
.custom-nav-bar {
  height: 56px;
  box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.3), 0px -2px 22px 0px rgba(53, 189, 128, 0.61);

  &>* {
    height: 100%;
  }
}



.vip {
  margin: 0 15px 60px 15px;
}

/* 从个人中心跳转时的特殊样式 */
.vip.from-person {
  margin: 0;
  padding: 15px;
  min-height: 100%;
  overflow-y: auto;

  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.vip-bottom-content {
  margin-top: auto;
  /* 推到底部 */
  margin-bottom: 30px;
  /* 底部间距 */
}

.vip-bottom-content.from-person {
  margin-bottom: 80px;
  /* 为底部tab预留空间，让内容定位到原来tab的位置 */
}


.coletarBtn.active {
  background: linear-gradient(0deg, #FABD63 0%, #F19C32 100%);
  color: #FEFBCB;
  font-weight: bold;
  box-shadow: 0 2px 8px rgba(254, 246, 74, 0.3);
}



.activity-header {
  // display: flex;
  // align-items: center;
  // margin-top: 10px;

}

.tabs {
  display: flex;
  overflow-x: auto;
  white-space: nowrap;
  scrollbar-width: none;
  height: 100%;
  align-items: center;
}

.tabs::-webkit-scrollbar {
  display: none;
}

.tab-item {
  position: relative;
  padding: 12px 12px;
  color: #60B289;
  cursor: pointer;
  font-weight: 500;
  font-size: 10px;
  transition: color 0.2s, background 0.2s;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 0 0 auto;
  border-radius: 4px;
  justify-content: center;
  height: 100%;
}

.tab-item:last-child {
  margin-right: 0;
}

.tab-item.active {
  color: #ffffff;
  border-radius: 4px;
  font-weight: bold;
  z-index: 1;
}

.tab-item:active {
  background: rgba(255, 255, 255, 0.08);
}

.tab-label-wrapper {
  display: inline-block;
  position: relative;
  // padding-bottom: 10px;
}

/* 标签红点样式 */
.tab-badge-dot {
  position: absolute;
  top: -2px;
  right: -8px;
  width: 6px;
  height: 6px;
  background: #F25A56;
  border-radius: 50%;
}

.tab-underline {
  display: block;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -7px;
  height: 2px;
  width: 100%;
  min-width: 50px;
  background: #15BB64;
  border-radius: 2px 2px 0 0;
  margin: 0 auto;
  transition: width 0.2s;
  content: "";
}

.bonus-table {}

.table-header {
  display: flex;
  color: #60B289;
  font-size: 12px;
  font-weight: 500;
  gap: 0;
  padding: 22px 0;
  background: #1F6749;
}

.th {
  flex: 1;
  text-align: center;
  padding: 8px 0;
}

.table-row {
  display: flex;
  font-size: 12px;
  color: #fff;
  align-items: center;
  min-height: 36px;
}

.table-row .td {
  flex: 1;
  text-align: center;
  padding: 8px 0;
}

.table-row.zebra {
  background: rgba(64, 182, 101, 0.08);
}
</style>
